export type BemHelperType = (elementOrModifiers?: string | string[] | false, modifiers?: string[] | false) => string;

const elementSeparator = '__';
const modifierSeparator = '_';

const getModifiers = (blockOrElement: string, modifiers: string[]): string =>
  modifiers.map((modifier) => `${blockOrElement}${modifierSeparator}${modifier}`).join(' ');

export const getBemHelper: (block: string) => BemHelperType =
  (block) =>
  (elementOrModifiers, modifiers): string => {
    /* block only */
    if (!elementOrModifiers) {
      return block;
    }

    /* block + modifiers */
    if (Array.isArray(elementOrModifiers)) {
      return `${block} ${getModifiers(block, elementOrModifiers)}`;
    }

    const element = `${block}${elementSeparator}${elementOrModifiers}`;

    /* element + modifiers */
    if (Array.isArray(modifiers)) {
      return `${element} ${getModifiers(element, modifiers)}`;
    }

    /* element only */
    return element;
  };
